var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavRtl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 228.3 226.2",
    enableBackground: "new 0 0 228.3 226.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    fill: "#FFFFFF",
    width: 226.2,
    height: 226.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 148.9,
    y: 96.8,
    fill: "#A60610",
    width: 58,
    height: 32.6
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    className: "rtl",
    points: "166.9,104.3 171,104.3 171,118.4 188.9,118.4 188.9,121.9 166.9,121.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "middle_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.2,
    y: 96.8,
    fill: "#D4000D",
    width: 58,
    height: 32.6
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    className: "rtl",
    points: "112.1,107.8 102,107.8 102,104.3 126.3,104.3 126.3,107.8 116.2,107.8 116.2,121.9 112.1,121.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.4,
    y: 96.8,
    fill: "#FA0000",
    width: 58,
    height: 32.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    className: "rtl",
    d: "M37.9,104.3h15.4c4.7,0,7.3,2.1,7.3,5.7c0,3-2,5.1-5.3,5.6l7.6,6.4h-5.8l-7.1-6.2h-8.1v6.2h-4V104.3z  M52.8,112.4c2.5,0,3.7-0.8,3.7-2.4c0-1.6-1.2-2.4-3.7-2.4H41.9v4.9H52.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavRtl);
export default __webpack_public_path__ + "static/media/nav_rtl.269eafe3468f9799622968734de5a238.svg";
export { ForwardRef as ReactComponent };